import api from 'api/ApiClient';

import { getShippingCost } from './selectors';

api.setCsrfToken();

const { gon } = window;
const { current_order: currentOrder, products } = gon;
const subscribed = gon.user ? gon.user.subscribed : false;

const variants = products.reduce((collection, product) => {
  return collection.concat(product.variants);
}, []);

const initialState = {
  addToCartSuccessQuantity: null,
  collectionsPending: [],
  commitmentDetailsIsOpen: false,
  committedUntil: gon.user && gon.user.committed_until,
  currentOrder,
  flashMessages: [],
  hasCanceledSubscription: gon.user && gon.user.subscription_canceled,
  hasSavedCart: false,
  isCollectionSavingRequest: false,
  isOpen: false,
  learnMoreIsOpen: false,
  lineItemsPending: [],
  lineItemsProcessing: [],
  membershipDiscountRate: gon.membership_discount_rate,
  minimumSubscriptionItems: gon.minimumSubscriptionItems,
  nicotineStrengthDetailsIsOpen: false,
  pendingPrice: 0,
  pendingQuantity: 0,
  products,
  sidebarIsFocused: false,
  canBecomeMember: gon.can_become_member,
  subscribableVariantDiscountRate:
    gon.eligible_subscription_plan_params &&
    gon.eligible_subscription_plan_params['subscribable_variant_discount_rate'],
  subscribableVariantFreeFrequency:
    gon.eligible_subscription_plan_params &&
    gon.eligible_subscription_plan_params[
      'subscribable_variant_free_frequency'
    ],
  subscribed,
  variantsSaving: [],
  variants,
};

initialState.shippingCost = getShippingCost(initialState);

export default initialState;



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/initialState.js